module.exports = __webpack_public_path__ + "1f77bd872fc434604a7b9fb238bd6d5d.MP3";